export default function(actionType) {
    const titles = {
        view: 'Просмотр',
        create: 'Создание',
        update: 'Изменение',
        delete: 'Удаление',
        restore: 'Восстановление',
        force_delete: 'Полное удаление',

        approve: 'Согласование',
        sign: 'Подписание',
        revoke: 'Отзыв',
        rework: 'Доработка',
        decline: 'Отказ',
        remind: 'Напоминание',
        upload_attachment: 'Загрузка приложения к документу',
        delete_attachment: 'Удаление приложения к документу',

        upload_personal_document: 'Загрузка личного документа',
        delete_personal_document: 'Удаление личного документа',

        add_representative: 'Добавление представителя',
        remove_representative: 'Удаление представителя',
        toggle_representative: 'Изменение статуса представителя',
        update_attorney: 'Обновление МЧД',

        generate_signature: 'Генерация подписи',

        update_avatar: 'Добавление аватара',
        delete_avatar: 'Удаление аватара',
        reset_password: 'Сброс пароля',
        update_password: 'Обновление пароля',

        accept_team_invitation: 'Принятие приглашения',
        decline_team_invitation: 'Отклонение приглашения',

        login: 'Авторизация',
        logout: 'Выход из системы',

        activate_2fa: 'Включение двухфакторной аутентификации',
        deactivate_2fa: 'Отключение двухфакторной аутентификации',
        delete_browser_sessions: 'Завершение сеансов в других браузерах',
    }
    return titles[actionType];
}
